import { faArrowsToEye } from "@fortawesome/pro-solid-svg-icons";
import { useImagePreviewHandlers } from "../../image-preview-context";
import { Tool } from "./tool";
import { ToolboxToolProps } from "./toolbox.types";

/**
 * Reset tool for the ImagePreview toolbox. Resets zoom, rotation and translation.
 */
export const Reset = (props: ToolboxToolProps) => {
    const handlers = useImagePreviewHandlers();
    return <Tool icon={faArrowsToEye} label="Reset" onClick={handlers.reset} {...props} />;
};
